import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { colorAccent, colorHover, colorText, sidebarColor } from '@/utils/palette';
import { left } from '@/utils/directions';

const SidebarExternalLink = ({ title, icon = '', url, onClick }) => {
	const handleClick = (e) => {
		e.preventDefault();
		if (url) {
			window.open(url, '_blank');
		}
		if (onClick) {
			onClick();
		}
	};

	return (
		<li>
			<SidebarExternalNavLink
				title={title}
				href={url}
				onClick={handleClick}
			>
				{icon ? <SidebarLinkIcon className={`lnr lnr-${icon}`} /> : ''}
				<SidebarLinkTitle>
					{title}
				</SidebarLinkTitle>
			</SidebarExternalNavLink>
		</li>
	);
};

SidebarExternalLink.propTypes = {
	title: PropTypes.string.isRequired,
	icon: PropTypes.string,
	url: PropTypes.string,
	onClick: PropTypes.func,
};

export default SidebarExternalLink;

// region STYLES

export const SidebarExternalNavLink = styled.a`
	height: 36px;
	width: 240px;
	transition: all 0.3s;
	position: relative;
	cursor: pointer;
	display: flex;
	padding: 11px 20px;
	overflow: hidden;
	background: transparent;
	border: none;
	color: ${colorText};
	text-align: ${left};
	font-size: 14px;
	text-decoration: none;

	&:before {
		content: '';
		position: absolute;
		top: 0;
		height: 100%;
		width: 2px;
		background: ${colorAccent};
		opacity: 0;
		transition: all 0.3s;
		${left}: 0;
	}

	&:hover {
		text-decoration: none;
		background-color: ${colorHover};
		color: ${colorText};

		&:before {
			opacity: 1;
		}
	}

	@media screen and (min-width: 576px) {
		width: 100%;

		span {
			position: relative;
			animation: none;
			${left}: 0;
		}
	}
`;

export const SidebarLinkTitle = styled.span`
	margin: 0;
	font-size: 14px;
	line-height: 16px;
	position: relative;
	display: flex;
	align-items: center;
	white-space: nowrap;

	@media screen and (min-width: 576px) {
		${(props) =>
			props.$collapse &&
			`
			display :none
		`}
	}
`;

export const SidebarLinkIcon = styled.span`
	font-size: 12px;
	line-height: 12px;
	color: ${colorText};
	margin-right: 10px;
`;

// endregion 